import React from 'react'
import InputFieldUI from './InputFieldUI'
import DatePickerSF from '../input/DatePickerSF'
import './InputDate.css'

const InputDateUI = ({context, name, selectedDateISO, onChange,
    // label
    label, help, messageList, labelKey, helpKey,
    // behavior
    required, autoFocus, disabled, error, placeholder, showTimeSelect = false, showTimeSelectOnly = false,
    timeIntervals, startTime, endTime}) =>
  <InputFieldUI className='w_input_date' name={name} required={required}
    label={label} help={help} messageList={messageList} labelKey={labelKey} helpKey={helpKey}>
    <DatePickerSF context={context} name={name} selectedDateISO={selectedDateISO} onChange={onChange}
      autoFocus={autoFocus} disabled={disabled}
      placeholder={placeholder}
      showTimeSelect={showTimeSelect}
      showTimeSelectOnly={showTimeSelectOnly}
      timeIntervals={timeIntervals}
      startTime={startTime}
      endTime={endTime}
      className={error ? 'hasError' : ''}
    />
  </InputFieldUI>

export default InputDateUI
